import React, { useState } from 'react';
import { X, Copy, Check } from 'lucide-react';
import { useI18n } from '../i18n';

export default function SessionWrapModal({ wrap, onClose }) {
    const { t } = useI18n();
    const [copied, setCopied] = useState(false);
    if (!wrap) return null;

    const copyShare = async () => {
        try {
            await navigator.clipboard.writeText(wrap.shareText || '');
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.warn('Clipboard copy failed', err);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose} role="presentation">
            <div className="modal-content session-wrap-modal" onClick={(event) => event.stopPropagation()}>
                <button type="button" className="close-btn" onClick={onClose} aria-label={t.common.close}>
                    <X size={18} />
                </button>
                <h2>{t.sessionWrap.title}</h2>
                {wrap.gameName && <p className="session-wrap-game">{wrap.gameName}</p>}
                {wrap.winnerName && (
                    <p>{t.sessionWrap.winner}: <strong>{wrap.winnerName}</strong></p>
                )}
                {wrap.tight && <p>{t.sessionWrap.photoFinish}</p>}
                <pre className="session-wrap-text">{wrap.shareText}</pre>
                <button type="button" className="btn-primary" onClick={copyShare}>
                    {copied ? <Check size={16} /> : <Copy size={16} />}
                    {copied ? t.sessionWrap.copied : t.sessionWrap.copy}
                </button>
            </div>
        </div>
    );
}
